<template>
  <!-- Deprecated: could use in the future -->
  <div>
    <notification-bell
      :notifications="userNotifications"
      :deleteNotificationFunc="deleteNotification"
      :actionEngine="engine"
    />
  </div>
</template>

<script>
import AWS from 'aws-sdk'
import AWSMqtt from 'aws-mqtt'
import {NotificationBell} from '@/components/common/notifications'
import { DELETE_NOTIFICATION, UPDATE_NOTIFICATION, SET_NOTIFICATIONS } from '@/appLogic/notifications/store/actions'
import NotificationEngine from '@/appLogic/notifications/NotificationEngine'

// TODO adding the webSocket makes this component Tight, should somewhere else
let webSocketClient

// try {
//   AWS.config.region = process.env.AWS_REGION || 'us-east-1'
//   AWS.config.credentials = new AWS.CognitoIdentityCredentials({
//     IdentityPoolId: process.env.IDENTITY_POOL_ID || 'us-east-1:d54277f3-65c1-40af-bbb6-9686b9319713'  // supply fallback values for local builds
//   })
//   webSocketClient = AWSMqtt.connect({
//     WebSocket: window.WebSocket,
//     region: AWS.config.region,
//     credentials: AWS.config.credentials,
//     endpoint: process.env.IOT_ENDPOINT || 'a3z4zzx2a3jmb-ats.iot.us-east-1.amazonaws.com',
//     clientId: 'mqtt-client-' + (Math.floor((Math.random() * 100000) + 1)) // clientId to register with MQTT broker. Need to be unique per client
//   })
// } catch (e) {
//   console.error('error initializing websocket connection!', e)
// }

export default {
  components: {
    NotificationBell
  },
  data () {
    return {
      engine: new NotificationEngine()
    }
  },
  beforeMount () {
    // this.loadNotifications()
    // this.initializeWebsocket()
  },
  computed: {
    userNotifications () {
      return this.$store.getters.userNotifications
    },
    username () {
      return this.$store.getters.username
    }
  },
  methods: {
    deleteNotification (notification) {
      this.$store.dispatch(DELETE_NOTIFICATION, notification)
    },
    loadNotifications () {
      this.$store.dispatch(SET_NOTIFICATIONS, this.username)
    },
    updateNotification (notification) {
      this.$store.dispatch(UPDATE_NOTIFICATION, notification)
    },
    initializeWebsocket () {
      if (!webSocketClient) return

      webSocketClient.on('connect', () => {
        console.log('connected to iot endpoint!')
        webSocketClient.subscribe(`/${this.username}/notifications`)
      })
      webSocketClient.on('message', (topic, message) => {
        let msg = message.toString()
        try {
          msg = JSON.parse(msg)
          console.log(topic, 'lambda message received!', msg)

          switch (msg.msgType) {
            case 'new':
              this.loadNotifications()
              break
            case 'update':
              this.updateNotification(msg.notification)
              break
            default: this.loadNotifications()
          }
        } catch (e) {}
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// AudienceMattersNotifications.vue?27edddfc